import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import { TabList as AriaTabList, TabListProps } from "react-aria-components";

import { useColors } from "../../../hooks/useColors";

export function TabList<T extends object>(props: TabListProps<T>) {
  const colors = useColors();

  return (
    <AriaTabList
      {...mergeProps(props, {
        className: css(styles.tablist, {
          "&[data-orientation=horizontal]": {
            boxShadow: `inset 0 -1px 0 0 ${colors["border-base"]}`,
            flexDirection: "row",
          },
          "&[data-orientation=vertical]": {
            flexDirection: "column",
            flexShrink: 0,
          },
        }),
      })}
    />
  );
}

const styles = {
  tablist: css({ display: "flex", flexDirection: "row" }),
};
